// extracted by mini-css-extract-plugin
export var dropdownContainer = "_m1-0";
export var leftAlign = "_m1-4";
export var listItem = "_m1-2";
export var listItemWrapper = "_m1-1";
export var operationText = "_m1-3";